"use strict";

var _interopRequireDefault = require("/data/jenkins/workspace/test-e-youhuo/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/data/jenkins/workspace/test-e-youhuo/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/data/jenkins/workspace/test-e-youhuo/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _zh_CN = _interopRequireDefault(require("ant-design-vue/es/locale/zh_CN"));

var _xqjrPluginCommon = require("xqjr-plugin-common");

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
var _default = {
  name: "App",
  components: {
    Common: _xqjrPluginCommon.Common
  },
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: true,
      zh_CN: _zh_CN.default
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)(["app"])),
  beforeCreate: function beforeCreate() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(process.env.VUE_APP_DYNAMIC_CONFIG === "true")) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.$store.dispatch("settings/changeSetting");

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    // 用于标记请求状态，防止相同状态重复弹出提醒
    localStorage.removeItem("reqStatus"); // const userMsg = localStorage.getItem("userMsg")
    // !!userMsg && this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(userMsg)))
    // // 在页面刷新时将vuex里的信息保存到localStorage里
    // window.addEventListener("beforeunload", () => {
    //   localStorage.setItem("userMsg", JSON.stringify(this.$store.state));
    // });

    this.$store.dispatch("auth/checkToken").catch(function () {
      _this2.$store.dispatch("auth/refreshToken").catch(function () {
        _this2.$store.dispatch("auth/resetToken");
      });
    });
  },
  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  }
};
exports.default = _default;